import { Component, Input, OnInit } from '@angular/core';
import { Sensor } from '../sensor';

@Component({
    selector: 'sensor-h2',
    templateUrl: 'sensor-h2.component.html',
    styleUrls: ['./sensor-h2.component.scss']
})
export class SensorH2Component implements OnInit {
    @Input() sensor: Sensor;
    constructor() { }

    ngOnInit() { }
}